import React from 'react'
import styles from '../../styles/Home.module.css'
import { Container } from 'react-bootstrap'

const ContentLayout = ({ children }) => {
  return (
    <>
      <Container fluid className={styles.glossaryBG}>{children}</Container>
    </>
  )
}

export default ContentLayout
